import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FadeLoader } from "react-spinners";
import { ImFilePdf, ImImage, ImFileWord, ImFileExcel } from "react-icons/im";
import { Helmet } from "react-helmet";
import "./stilovi.css";
import GalleryFromHTML from "../galerija/GalleryFromHTML";
import Sadrzaj from "./Sadrzaj";

const NovostDetalj = () => {
  const { id } = useParams();
  const [novost, setNovost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    axios
      .get("https://www.asu.unsa.ba/v2/index.php", {
        params: {
          rest_route: `/wp/v2/posts/${id}`,
          _embed: true,
          _fields: "id,title,content,excerpt,acf,_embedded,date",
          acf_format: "standard",
        },
      })
      .then((res) => {
        setNovost(res.data);
      })
      .catch((error) => {
        console.error("Greška prilikom dohvata podataka o postu:", error);
        setNovost(null);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const title = novost?.title?.rendered || "Novost";
  const description = novost?.excerpt?.rendered
    ? novost.excerpt.rendered.replace(/<[^>]+>/g, "").slice(0, 200)
    : "";

  const ogImage =
    novost?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.medium
      ?.source_url ||
    novost?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
    "";

  const featuredImg =
    novost?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.medium
      ?.source_url ||
    novost?._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
    "";

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta property="og:title" content={title} />
        {description ? <meta property="og:description" content={description} /> : null}
        {ogImage ? <meta property="og:image" content={ogImage} /> : null}
      </Helmet>

      <div className="container drugaSekcija dekanat nastavnik">
        <div className="container dekanat">
          {loading ? (
            <div
              className="text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh",
              }}
            >
              <FadeLoader color="#123abc" loading={loading} />
            </div>
          ) : !novost ? (
            <p style={{ padding: 20 }}>Podaci nisu dostupni.</p>
          ) : (
            <main role="main" className="container drugaSekcija">
              <div className="row">
                <h3>{title}</h3>

                <Sadrzaj htmlContent={novost?.content?.rendered || ""} />

                <div id="stilizirani-div">
                  <GalleryFromHTML htmlContent={novost?.content?.rendered || ""} />
                </div>

                {featuredImg ? (
                  <img
                    className="img-fluid img-thumbnail"
                    alt={title}
                    src={featuredImg}
                  />
                ) : null}

                <p>
                  {novost?.acf?.dokumenti?.length
                    ? novost.acf.dokumenti.map((el) => {
                        const url = el?.dokument?.url;
                        const subtype = el?.dokument?.subtype;

                        if (!url) return null;

                        let Icon = null;
                        if (subtype === "pdf") Icon = ImFilePdf;
                        else if (["jpeg", "jpg", "png"].includes(subtype)) Icon = ImImage;
                        else if (["doc", "docx"].includes(subtype)) Icon = ImFileWord;
                        else if (
                          subtype ===
                            "vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                          subtype === "vnd.ms-excel" ||
                          subtype === "xls" ||
                          subtype === "xlsx"
                        )
                          Icon = ImFileExcel;

                        return (
                          <a
                            key={el?.naziv_dokumenta || url}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ marginRight: 10 }}
                          >
                            {Icon ? <Icon size={25} /> : "Dokument"}
                          </a>
                        );
                      })
                    : null}
                </p>
              </div>
            </main>
          )}
        </div>
      </div>
    </>
  );
};

export default NovostDetalj;
